/*
  Still used in Sweetwater road list and Teton Road & S/D lists
  2007 mapserv (non-vector) highlighting
  2017 added ol3 compatibility
  2019-12 don't create a new olLayer each time we're called; don't use filter
  2019-12 remove filter=key=val syntax for mapsevr v.7 compatibility
  2024-04-01 removed reprojection, response must be in coord system as map*
*/

export default function(map) {
  function itemQuery(filter, qlayer, zoom) {
    rwg.filter = filter;
    rwg.qlayer = qlayer;
    let params = {
      LAYERS: qlayer
    };
    let filterParsed = filter.split('=');
    params[filterParsed[0]] = filterParsed[1];
    let lyrQuery = rwg.map.getLayerByTitle('lyrQuery');
    lyrQuery.getSource().updateParams(params);
    lyrQuery.setVisible(true);

    if (zoom !== false) {
      fetch( 'getBox.php?filter=' + filter + '&qlayer=' + qlayer)
      .then(response => response.text())
      .then(text => {
        let tokens = text.split(',').map(e => parseFloat(e))
        if (isNaN(tokens[0])) {
          console.error("invalid response:" + text);
        } else {
          let view = map.getView();
          view.fit(tokens, map.getSize());
          view.setCenter( [((tokens[0]) + (tokens[2])) / 2, ((tokens[1]) + (tokens[3])) / 2] );
        }
      })
    }
  }

  return itemQuery;
}
